import React from 'react';

type Props = {
	icon: React.FC<React.SVGProps<SVGSVGElement>>;
	label: string;
	value: string | number;
};

const EPopupElement: React.FC<Props> = ({ icon: Icon, label, value }) => (
	<div className='py-3 flex items-center gap-2.5 text-sm'>
		<Icon className='stroke-popover-1000' />
		<span>{label}</span>
		<span className='ml-auto'>{value}</span>
	</div>
);

export default EPopupElement;
